import { AlertTriangle, CheckCircle2, Clock, type LucideIcon, XCircle } from "lucide-react";

import { ColocaStatusPill } from "@/shared/components/data-display/ColocaStatusPill";
import type { VerificationTranslations } from "@/shared/lang/interfaces/verification";
import useTranslations from "@/shared/lang/useTranslations";

import type { KycStatus } from "../types/verification-api.types";

type PillVariant = "success" | "warning" | "info" | "danger" | "neutral";

const STATUS_PILL: Record<
  KycStatus,
  { variant: PillVariant; icon: LucideIcon; labelKey: keyof VerificationTranslations }
> = {
  PENDING: { variant: "warning", icon: Clock, labelKey: "status_pending" },
  IN_REVIEW: { variant: "info", icon: Clock, labelKey: "status_in_review" },
  VERIFIED: { variant: "success", icon: CheckCircle2, labelKey: "status_verified" },
  REJECTED: { variant: "danger", icon: XCircle, labelKey: "status_rejected" },
  EXPIRED: { variant: "neutral", icon: AlertTriangle, labelKey: "status_expired" },
};

/** Semantic KYC/KYB status pill (color + icon + label) used across the verification frames. */
export function KycStatusPill({ status }: { status: KycStatus }) {
  const { t } = useTranslations("verification");
  const meta = STATUS_PILL[status] ?? STATUS_PILL.PENDING;
  return (
    <ColocaStatusPill variant={meta.variant} icon={meta.icon}>
      {t(meta.labelKey)}
    </ColocaStatusPill>
  );
}
